/* @ngInject */
export default function findboxModalController() {}
